import { handleActions } from 'redux-actions';
import {
  addFolderItem,
  addFolderItems,
  changeGeneralSearchTextClient,
  changeSortConfigClient,
  loadAllClients,
  paginateClients,
  removeFolderItem,
  removeFolderItems,
  selectCustomFolder,
  setClearClientList,
  selectCurrentClient,
  setNewCommunication,
  setDeleteClientFromHome,
  setSelectedCustomField,
} from '../actions/clientActions';

const defaultState = {
  clients: [],
  currentClient: undefined,
  currentClients: [],
  selectedCustomFolder: undefined,
  generalSearchText: undefined,
  sortConfig: [],
  clearList: false,
  newCommunication: undefined,
  isDeleteClientFromHome: false,
  selectedCustomField: [],
};

export default handleActions(
  {
    [loadAllClients](state, action) {
      return { ...state, clients: action.payload };
    },
    [selectCurrentClient](state, action) {
      return { ...state, currentClient: action.payload };
    },
    [changeGeneralSearchTextClient](state, action) {
      return { ...state, generalSearchText: action.payload };
    },
    [changeSortConfigClient](state, action) {
      const { fieldName, isSort } = action.payload;
      return {
        ...state,
        sortConfig: [{ model: 'Client', field: fieldName, asc: isSort }],
      };
    },
    [setClearClientList](state, action) {
      const clearList = action.payload;
      const generalSearchText = clearList ? undefined : state.generalSearchText;
      const sortConfig = clearList
        ? [{ model: 'Client', field: 'ClientName', asc: true }]
        : state.sortConfig;
      return { ...state, generalSearchText, sortConfig, clearList };
    },
    [paginateClients](state, action) {
      const { page, pageSize } = action.payload;
      const start = (page - 1) * pageSize;
      const end = page * pageSize;
      const currentClients = [...state.clients].slice(start, end);
      return { ...state, currentClients };
    },
    [addFolderItems](state, action) {
      const { clientId, items } = action.payload;
      const newClientsData = state.clients.map((client) =>
        client.id === clientId ? { ...client, items } : client
      );
      return { ...state, clients: newClientsData };
    },
    [removeFolderItems](state, action) {
      const clientId = action.payload;
      const newClientsData = state.clients.map((client) =>
        client.id === clientId ? { ...client, items: undefined } : client
      );
      return { ...state, clients: newClientsData };
    },
    [addFolderItem](state, action) {
      const { clientId, item } = action.payload;
      const newClientsData = state.clients.map((client) =>
        client.id === clientId ? { ...client, items: [...client.items, item] } : client
      );
      return { ...state, clients: newClientsData };
    },
    [removeFolderItem](state, action) {
      const { clientId, itemId } = action.payload;
      const newClientsData = state.clients.map((client) =>
        client.id === clientId
          ? { ...client, items: client.items.filter((item) => item.id !== itemId) }
          : client
      );
      return { ...state, clients: newClientsData };
    },
    [selectCustomFolder](state, action) {
      return { ...state, selectedCustomFolder: action.payload };
    },
    [setNewCommunication](state, action) {
      return { ...state, newCommunication: action.payload };
    },
    [setDeleteClientFromHome](state, action) {
      return { ...state, isDeleteClientFromHome: action.payload };
    },
    [setSelectedCustomField](state, action) {
      return { ...state, selectedCustomField: action.payload };
    },
  },
  defaultState
);
